var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"waggon-info-status t-rounded",style:(`
    width: ${_vm.width?_vm.width:''};
    border: ${_vm.selected && !_vm.no_border?`solid 1px ${_vm.status.name === 'stop'?'#F44336':'black'}`:''};
    ${_vm.bold?'font-weight: bold;':''}
    ${_vm.cursor?`cursor: ${_vm.cursor};`:''}
    `)},[(_vm.status.icon === 'ai_stop')?_c('AIIcon',{staticClass:"mr-1",attrs:{"width":"16px","color":"#F44336"}}):_c('v-icon',{staticClass:"mr-1",attrs:{"small":"","color":_vm.status.name === 'stop' && _vm.selected?'#F44336':_vm.textcolor}},[_vm._v(" "+_vm._s(_vm.status.icon)+" ")]),(!_vm.no_text || _vm.selected)?_c('div',{style:(`
      ${_vm.status.name === 'stop' && _vm.selected?'color: #F44336':''}
      ${_vm.$vuetify.breakpoint.smAndDown?'font-size: 8px;':''}
      `)},[(_vm.status.name === 'stop')?_c('div',[_vm._v(" "+_vm._s(_vm.status.name)+" ")]):_c('div',[_vm._v(" "+_vm._s(_vm.$t(`Project.Workpackage.Status.${_vm.status.tooltip}`))+" ")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }